import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../state/AuthProvider";
import { useLocale } from "../state/i18n";
import { ErrorFlash } from "../components/ErrorFlash";
import { PrototypeBanner, PublicNav } from "../components/ui";

export function ForgotPassword() {
  const { requestPasswordReset } = useAuth();
  const { t } = useLocale();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState<{
    email: string;
    token: string;
    channel: "local" | "supabase";
  } | null>(null);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    const result = await requestPasswordReset(email);
    setBusy(false);
    if (!result.ok) {
      setError(result.error);
      return;
    }
    setSent({ email: result.email, token: result.token, channel: result.channel });
  }

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <PublicNav />
        <div className="auth-panel">
          <p className="meta">{t("forgot.meta")}</p>
          <h1>{t("forgot.title")}</h1>
          {sent ? (
            <>
              <p className="lede">{t("forgot.sent", { email: sent.email })}</p>
              <div className="wire auth-mail">
                <div className="meta">{t("done.mailMeta")}</div>
                <div className="row">
                  <div>
                    <strong>{t("forgot.mailTitle")}</strong>
                    <div className="anno">{t("forgot.mailTo", { email: sent.email })}</div>
                  </div>
                </div>
                <p style={{ margin: "0.85rem 0 0" }}>{t("forgot.mailBody")}</p>
                {sent.channel === "local" ? (
                  <div className="actions">
                    <Link
                      className="btn"
                      to={`/reset-password?token=${encodeURIComponent(sent.token)}`}
                    >
                      {t("forgot.choose")}
                    </Link>
                  </div>
                ) : null}
              </div>
              <p className="auth-links">
                <Link to="/signin">{t("forgot.back")}</Link>
              </p>
            </>
          ) : (
            <>
              <p className="lede">{t("forgot.lede")}</p>
              <form className="stack" onSubmit={onSubmit}>
                <div className="field">
                  <label htmlFor="email">{t("forgot.email")}</label>
                  <input
                    id="email"
                    type="email"
                    autoComplete="username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                {error ? <ErrorFlash key={error} message={error} /> : null}
                <div className="actions">
                  <button type="submit" disabled={busy}>
                    {busy ? t("forgot.sending") : t("forgot.send")}
                  </button>
                  <Link className="btn ghost" to="/signin">
                    {t("forgot.back")}
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
